import React, { MouseEvent } from "react";
import { AxiosResponse } from "axios";
import { withTranslation, WithTranslation } from "react-i18next";
import {
    LoadPanel,
    TextBox,
    CheckBox,
    NumberBox,
    DateBox,
    FileUploader,
    Button,
    LoadIndicator,
} from "devextreme-react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import LookupService, { LookupTypeIndexes, LookupTypeItem } from "../../services/LookupService";
import DropDownFromLookupTableDynamic from "../select/SelectBoxFromLookupTableDynamic";
import DropDownFromLookupTable from "../select/SelectBoxFromLookupTable";
import promotionTemplatesService from "../../services/PromotionTemplatesService";
import ServiceFeeService from "../../services/ServiceFeesService";
import BillingFormUtils from "../Billing/BillingFormUtils";
import SelectBoxFromLookupBrandTableDynamic from "../select/SelectBoxFromLookupBrandTableDynamic"
import {
    SelectBoxOnValueChangedEvent,
    CheckBoxOnValueChanged,
    NumberBoxOnValueChangedEvent,
    DateBoxOnValueChangedEvent,
} from "../../types/DevExtremeTypes";
import CookieService, { DXGridCookieKeyTypes } from "../../services/CookieService";
import promotionTemplatesFormUtil, {
    AddEditPromotionTemplatesFormData,
} from "../../../src/components/Matrix/PromotionTemplatesUtils";
import {
    FileUploaderOnValueChangedEvent,
    FileUploadOnInitializedEvent,
    TextBoxOnValueChangedEvent,
    TagBoxOnValueChangeEvent,
    RadioButtonOnSelectionChanged,
    OnRowUpdatingEvent,
    OnRowInsertingEvent,
    OnRowRemovingEvent,
    onEditCanceledEvent,
} from "../../types/DevExtremeTypes";
import "../../../assets/scss/components/_promotion-templates.scss";
import { isValidImageFileType, isValidDocumentFileType } from "../../common/CommonUIUtils";
type NullableDate = Date | null | undefined;
//#region props
interface PromotionTemplatesFormProps extends WithTranslation {
    location: any;
    history: any;
    onApplySuccess: (applySignal: string) => void;
    isEditForm: any;
}

// State
interface PromotionTemplatesFormState {
    //TODO : Define the form state here.
    clientLookUp: LookupTypeItem[];
    serviceLookUp: LookupTypeItem[];
    subServiceLookUp: LookupTypeItem[];
    venueLookUp: LookupTypeItem[];
    providerLookUp: LookupTypeItem[];
    frequencyLookUp: LookupTypeItem[];
    editServiceFeeFormData: AddEditPromotionTemplatesFormData;
    //PeriodMatrix: any;
    loadPanelVisible: boolean;
    disableDayTextbox: boolean;
    filterId: string;
    errorMessage: [];
    showError: boolean;
    originator: any[];
    isPrimaryPhotoAdded: boolean;
    promotionPhotoHolder: string;
    selectedPrimaryFileContent: string;
    loadIndicatorVisibleForPrimaryUpload: boolean;
    selectedPromotionFile: File[];
    IsShowSuccess: boolean;
    IsShowError: boolean;
    //weekLookUp: LookupTypeItem[];
}

class PromotionTemplatesForm extends React.Component<PromotionTemplatesFormProps> {
    lookupService: LookupService;
    state: PromotionTemplatesFormState;
    utils: promotionTemplatesFormUtil;
    cleaningService: ServiceFeeService;
    periodWeekUtil: BillingFormUtils;
    fileUploadElementForPrimaryPhoto: any;
    promotionTemplateService: promotionTemplatesService;
    constructor(props: PromotionTemplatesFormProps) {
        super(props);
        this.lookupService = new LookupService();
        this.utils = new promotionTemplatesFormUtil();
        this.cleaningService = new ServiceFeeService();
        this.periodWeekUtil = new BillingFormUtils();
        this.promotionTemplateService = new promotionTemplatesService();
        this.fileUploadElementForPrimaryPhoto = undefined;
        let convertedEditPeriodData = this.utils.initializePromotionTemplateFormItem();
        this.state = {
            clientLookUp: [],
            serviceLookUp: [],
            subServiceLookUp: [],
            venueLookUp: [],
            providerLookUp: [],
            frequencyLookUp: [],
            editServiceFeeFormData: convertedEditPeriodData,
            loadPanelVisible: false,
            disableDayTextbox: false,
            filterId: "20",
            errorMessage: [],
            showError: false,
            originator: [],
            isPrimaryPhotoAdded: false,
            loadIndicatorVisibleForPrimaryUpload: false,
            promotionPhotoHolder: "",
            selectedPrimaryFileContent: "",
            selectedPromotionFile: [],
            IsShowSuccess: false,
            IsShowError: false,
        };
    }

    //#region 'componentDidMount and Service Call"
    componentDidMount() {
        this.getEditViewItemDataSource();
        this.lookupService
            .getLookupByLookupTypeIndex(LookupTypeIndexes.originator)
            .then(this.handleSuccesStatusLookUp)
            .catch(this.handleStandardError);
    }
    handleSuccesStatusLookUp = (response: AxiosResponse<any>) => {
        this.setState({
            originator: response.data.data,
        });
    };
    handleStandardError = (error: any) => {
        var respMessage: string = "Add/Edit shift form load failed with response: " + JSON.stringify(error);
        console.error(respMessage);
    };
    getEditViewItemDataSource = () => {
        if (this.props.location.state && this.props.location.state.id) {
            this.promotionTemplateService
                .getPromotionTemplateById(this.props.location.state.id)
                .then(this.handleSuccessViewDataSource)
                .catch(this.handleError);
        }
    };
    handleSuccessViewDataSource = (response: AxiosResponse<any>) => {
        let viewDataSource = this.utils.convertPromotionTemplateItemResponeToFormData(response.data.data);
        this.setState({
            editServiceFeeFormData: viewDataSource,
            promotionPhotoHolder: viewDataSource.link,
        });
    };

    handleError = (err: any) => {
        this.setState({
            errorMessage: err.response !== null ? JSON.parse(JSON.stringify(err.response.data.error)) : null, // For capturing response at the time of exception and showing error message
            showError: true,
            loadPanelVisible: false,
        });
    };

    handleChangeClient = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                businessEntityId: dxValueChange.value,
                brandId:""
            },
        });
    };
    handleChangeService = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                serviceTypeId: dxValueChange.value,
            },
        });
    };
    handleChangeServiceSubType = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                serviceSubTypeId: dxValueChange.value,
            },
        });
    };
    handleChangeBrandType = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                brandId: dxValueChange.value,
            },
        });
    };
    handleChangeServiceType = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                typeLookUpId: dxValueChange.value,
            },
        });
    };

    handleChangeServiceFee = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                serviceFeeCalculationLookUpId: dxValueChange.value,
            },
        });
    };

    handleChangeBudgetType = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                budgetTypeId: dxValueChange.value,
            },
        });
    };
    handleChangeActive = (dxValueChange: CheckBoxOnValueChanged) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                active: dxValueChange.value,
            },
        });
    };
    handleChangeFasterPayAvailable = (dxValueChange: CheckBoxOnValueChanged) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                fasterPayAvailable: dxValueChange.value,
            },
        });
    };
    handleChangeVisibiltyDateOverride = (dxValueChange: CheckBoxOnValueChanged) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                visibilityDateOverride: dxValueChange.value,
            },
        });
    };
    handleChangeEarlyPay = (dxValueChange: CheckBoxOnValueChanged) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                earlyPay: dxValueChange.value,
            },
        });
    };
    handleChangeOnlyBillApprovedItems = (dxValueChange: CheckBoxOnValueChanged) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                onlyBillApprovedItems: dxValueChange.value,
            },
        });
    };
    handleChangeRefund = (dxValueChange: CheckBoxOnValueChanged) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                refund: dxValueChange.value,
            },
        });
    };

    handleChangeAccruals = (dxValueChange: CheckBoxOnValueChanged) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                isAccruals: dxValueChange.value,
            },
        });
    };

    handleChangeProviderAcceptances = (dxValueChange: CheckBoxOnValueChanged) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                providerAcceptances: dxValueChange.value,
            },
        });
    };

    handleChangeMultiplier = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                multiplier: dxValueChange.value,
            },
        });
    };
    handleChangeFasterPayMultiplier = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                fasterPayMultiplier: dxValueChange.value,
            },
        });
    };
    handleChangeMinFee = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                minGrossProfitValue: dxValueChange.value,
            },
        });
    };
    handleChangeMaxFee = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                maxGrossProfitValue: dxValueChange.value,
            },
        });
    };

    handleChangeVisibiltyDate = (dxValueChange: DateBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                approvalVisibilityDate: dxValueChange.value,
            },
        });
    };

    handleChangeVisibiltyOffset = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                approvalVisibilityOffset: dxValueChange.value,
            },
        });
    };

    handleChangeVisibiltyOffsetBatch = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                approvalVisibilityOffsetBatch: dxValueChange.value,
            },
        });
    };

    handleChangeVisibiltyOffsetImport = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                approvalVisibilityOffsetImport: dxValueChange.value,
            },
        });
    };

    handleChangeMinOffer = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                makeOfferLowerAdjustment: dxValueChange.value,
            },
        });
    };

    handleChangeMaxOffer = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                makeOfferUpperAdjustment: dxValueChange.value,
            },
        });
    };

    handleChangeVisibiltyOffsetPayment = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                paymentOffset: dxValueChange.value,
            },
        });
    };

    handleChangeSourceApprovalMode = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                twoTierRequestApprovalMode: dxValueChange.value,
            },
        });
    };

    handleChangeSourceApprovalAmount = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState({
                editServiceFeeFormData: {
                    ...this.state.editServiceFeeFormData,
                    twoTierRequestApprovalAmount: dxValueChange.value,
                },
            });
        }
    };

    handleChangePostApprovalMode = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                twoTierBillableApprovalMode: dxValueChange.value,
            },
        });
    };

    handleChangePostApprovalAmount = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState({
                editServiceFeeFormData: {
                    ...this.state.editServiceFeeFormData,
                    twoTierBillableApprovalAmount: dxValueChange.value,
                },
            });
        }
    };

    handleChangeMarketplaceReduction = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                marketPlaceReduction: dxValueChange.value,
            },
        });
    };

    handleChangeTextStyle = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                promotionTemplateTextStylesId: dxValueChange.value,
            },
        });
    };
    onApplyClick = (type: string) => {
        this.setState({
            loadPanelVisible: true,
        });
        var formData = new FormData();
        if (this.state.selectedPromotionFile?.length > 0) {
            const file = this.state.selectedPromotionFile[0];
            formData.append("files[]", file, file.name);
        }
        formData.append(
            "BusinessEntityId",
            this.state.editServiceFeeFormData.businessEntityId ? this.state.editServiceFeeFormData.businessEntityId : ""
        );
        formData.append(
            "serviceTypeId",
            this.state.editServiceFeeFormData.serviceTypeId ? this.state.editServiceFeeFormData.serviceTypeId : ""
        );
        formData.append(
            "serviceSubTypeId",
            this.state.editServiceFeeFormData.serviceSubTypeId ? this.state.editServiceFeeFormData.serviceSubTypeId : ""
        );
        formData.append(
            "typeLookUpId",
            this.state.editServiceFeeFormData.typeLookUpId ? this.state.editServiceFeeFormData.typeLookUpId : ""
        );
        formData.append("linkTypeId", "91");
        formData.append("active", this.state.editServiceFeeFormData.active ? "True" : "False");
        formData.append(
            "description",
            this.state.editServiceFeeFormData.description ? this.state.editServiceFeeFormData.description : ""
        );
        formData.append("id", this.state.editServiceFeeFormData.id ? this.state.editServiceFeeFormData.id : "");
        formData.append("brandId", this.state.editServiceFeeFormData.brandId ? this.state.editServiceFeeFormData.brandId : "");
        formData.append("promotionTemplateTextStylesId", this.state.editServiceFeeFormData.promotionTemplateTextStylesId ? this.state.editServiceFeeFormData.promotionTemplateTextStylesId : "");
        this.promotionTemplateService
            .addEditPromotionTemplate(formData)
            .then((res) => {
                this.handleSuccessDataSubmission(res, type);
            })
            .catch((err) => {
                this.setState({
                    errorMessage:
                        err.response && err.response.data && err.response.data.error
                            ? JSON.parse(JSON.stringify(err.response.data.error))
                            : null,
                    IsShowSuccess: false,
                    loadPanelVisible: false,
                });
                this.failureMessageVisible();
            });
    };
    failureMessageVisible = () => {
        this.setState({
            IsShowError: true,
        });
    };

    handleErrorDataSubmission = (res: AxiosResponse<any>) => {};
    handleSuccessDataSubmission = (res: AxiosResponse<any>, type: string) => {
        let viewDataSource = this.utils.convertPromotionTemplateItemResponeToFormData(res.data.data);
        this.setState({
            editServiceFeeFormData: viewDataSource,
            loadPanelVisible: false,
        });
        if (type == "save") {
            this.props.onApplySuccess("SAVE");
        }else if (type == "ADD") {
            this.props.onApplySuccess("ADD");
        }else{
            this.props.onApplySuccess("EDIT");
        }
    };

    isBlank = (filterId: string) => {
        return !filterId || /^\s*$/.test(filterId) || 0 === filterId.length;
    };
    onCustomGridLoad() {
        return CookieService.loadDXGridConfiguration(DXGridCookieKeyTypes.rateMatrixGrid);
    }

    onCustomGridSave(gridState: Object) {
        CookieService.saveDXGridConfiguration(DXGridCookieKeyTypes.rateMatrixGrid, gridState);
    }
    setVenueCellValue = (rowData: any, value: any) => {
        rowData.id = value === 0 ? null : value;
    };
    calculateSortValue(this: any, data: any) {
        if (this) {
            if (this.dataField == "id") {
                return data.id;
            } else if (this.dataField == "multiplier") {
                return data.multiplier;
            }
        }
        return;
    }

    calculateFilterExpression(this: any, filterValue: any, selectedFilterOperation: any, target: any) {
        if (target == "filterRow") {
            if (selectedFilterOperation) {
                if (this.dataField == "id") {
                    return [["id", selectedFilterOperation, filterValue]];
                } else if (this.dataField == "multiplier") {
                    return [["multiplier", selectedFilterOperation, filterValue]];
                }
            }
            return this.defaultCalculateFilterExpression?.apply(this, arguments);
        }
        return this.defaultCalculateFilterExpression?.apply(this, arguments);
    }

    onSubmitPrimaryPhoto = () => {
        // if(this.props.businessEntityId == "0"){
        //     this.setState({
        //         showUploadWarningPopup: true,
        //     });
        // }
        // else {
        //     this.setState({
        //         loadIndicatorVisibleForPrimaryUpload: true,
        //     });
        //     var formData = new FormData();
        //     formData.append("linktypeid", OtherType.PrimaryPhoto);
        //     formData.append("files[]", this.state.selectedPrimaryFile[0], this.state.selectedPrimaryFile[0].name);
        //     formData.append("BusinessEntityId", this.props.businessEntityId ? this.props.businessEntityId : "");
        //     this.artistService
        //         .uploadPhoto(formData)
        //         .then(this.handlePrimaryPhotoUploadSuccess)
        //         .catch(this.handlePrimaryPhotoUploadUploadFailure);
        // }
    };
    onValueChangedForPromotionPhoto = (e: FileUploaderOnValueChangedEvent) => {
        var reader = new FileReader();
        if (e && e.value && e.value[0]) {
            if (isValidImageFileType(e.value[0].type)) {
                var that = this;
                reader.onload = (function (file) {
                    return function (e: any) {
                        that.setState({
                            promotionPhotoHolder: e.target.result,
                        });
                    };
                })(e.value[0]);
                reader.readAsDataURL(e.value[0]);
                this.setState({
                    isPrimaryPhotoAdded: true,
                    selectedPromotionFile: e.value,
                });
            } else {
                this.setState({
                    displayWrongFileTypeError: true,
                });
            }
        }
    };

    onPrimaryPhotoUploadInitialize = (e: FileUploadOnInitializedEvent) => {
        this.fileUploadElementForPrimaryPhoto = e.component;
    };
    onCancelPrimaryPhoto = () => {
        this.setState({
            isPrimaryPhotoAdded: false,
            selectedPrimaryFileContent: "",
        });
    };
    handleChangeDescription = (dxValueChange: TextBoxOnValueChangedEvent) => {
        this.setState({
            editServiceFeeFormData: {
                ...this.state.editServiceFeeFormData,
                description: dxValueChange.value,
            },
        });
    };
    //#region render Component
    render() {
        return (
            <>
                <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={this.state.loadPanelVisible} />
                <form data-testid="addEditShift-form" className="edit-form my-5 form_border">
                    <div className=" mb-6 edit-form__column">
                        <div className="row pt-3">
                            <h2 className="billingForm-heading">Promotion Template Form</h2>
                        </div>
                        <br></br>
                        <div className="row justify-content-left pt-3" hidden={!this.state.showError}>
                            <span className="text-danger font-weight-bold text-left">
                                <ul>
                                    {this.state.errorMessage.map((item: any, uniqueKey: number) => {
                                        return (
                                            <li key={uniqueKey}>
                                                {item.columnName}: {item.errorMessage}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </span>
                        </div>
                        <div className="fieldImage" style={{ marginLeft: "1rem" }}>
                            <div className="formFields">
                                <div className="row">
                                    <div className="mt-3 col-2 col-lg-2 font-weight-bold font_size">Client</div>
                                    <div className="mt-3 col-10 col-lg-6">
                                        <DropDownFromLookupTable
                                            lookupTypeIndex={LookupTypeIndexes.clientType}
                                            onValueChanged={this.handleChangeClient}
                                            value={this.state.editServiceFeeFormData.businessEntityId}
                                            recordType={
                                                this.props.location.state && this.props.location.state.id
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>

                                {/* added Brand dropdown : PBI 20945 */}
                                <div className="row">
                                    <div className="mt-3 col-2 col-lg-2 font-weight-bold font_size">Brand</div>
                                    <div className="mt-3 col-10 col-lg-6">
                                        <SelectBoxFromLookupBrandTableDynamic
                                            lookupTypeIndex={LookupTypeIndexes.brand}
                                            isRoot={true}
                                            parentMappingId={this.state.editServiceFeeFormData.businessEntityId}
                                            onValueChanged={this.handleChangeBrandType}
                                            value={this.state.editServiceFeeFormData.brandId}
                                        />
                                    </div>
                                </div>

                                
                                <div className="row">
                                    <div className="mt-3 col-2 col-lg-2 font-weight-bold font_size">Service</div>
                                    <div className="mt-3 col-10 col-lg-6">
                                        <DropDownFromLookupTable
                                            lookupTypeIndex={LookupTypeIndexes.serviceType}
                                            onValueChanged={this.handleChangeService}
                                            value={this.state.editServiceFeeFormData.serviceTypeId}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="mt-3 col-2 col-lg-2 font-weight-bold font_size">
                                        Service Sub Type
                                    </div>
                                    <div className="mt-3 col-10 col-lg-6">
                                        <DropDownFromLookupTableDynamic
                                            lookupTypeIndex={LookupTypeIndexes.subServiceType}
                                            isRoot={true}
                                            parentMappingId={this.state.editServiceFeeFormData.serviceTypeId}
                                            onValueChanged={this.handleChangeServiceSubType}
                                            value={this.state.editServiceFeeFormData.serviceSubTypeId}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="mt-3 col-2 col-lg-2 font-weight-bold font_size">Type</div>
                                    <div className="mt-3 col-10 col-lg-6">
                                        <DropDownFromLookupTableDynamic
                                            lookupTypeIndex={LookupTypeIndexes.offeringsType}
                                            isRoot={true}
                                            parentMappingId={this.state.editServiceFeeFormData.serviceSubTypeId}
                                            onValueChanged={this.handleChangeServiceType}
                                            value={this.state.editServiceFeeFormData.typeLookUpId}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="mt-3 col-2 col-lg-2 font-weight-bold font_size">Description</div>
                                    <div className="mt-3 col-10 col-lg-6">
                                        <TextBox
                                            readOnly={false}
                                            value={this.state.editServiceFeeFormData.description}
                                            onValueChanged={this.handleChangeDescription}
                                            valueChangeEvent="keyup"
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="mt-3 col-2 col-lg-2 font-weight-bold font_size">Text Style</div>
                                    <div className="mt-3 col-10 col-lg-6">
                                        <DropDownFromLookupTable
                                            lookupTypeIndex={LookupTypeIndexes.promotionTemplateTextStyles}
                                            onValueChanged={this.handleChangeTextStyle}
                                            value={this.state.editServiceFeeFormData.promotionTemplateTextStylesId}
                                            recordType={
                                                this.props.location.state && this.props.location.state.id
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="mt-3 col-2 col-lg-2 font-weight-bold font_size">
                                        Last Updated On
                                    </div>
                                    <div className="mt-3 col-10 col-lg-6">
                                        <TextBox
                                            value={this.state.editServiceFeeFormData.lastUpdatedOn}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="mt-3 col-2 col-lg-2 font-weight-bold font_size">
                                        Last Updated By
                                    </div>
                                    <div className="mt-3 col-10 col-lg-6">
                                        <TextBox
                                            value={this.state.editServiceFeeFormData.lastUpdatedBy}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="mt-3 col-2 col-lg-2 font-weight-bold font_size">Link</div>
                                    <div className="mt-3 col-10 col-lg-6">
                                        <TextBox value={this.state.editServiceFeeFormData.link} readOnly={true} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="mt-3 col-2 col-lg-2 font-weight-bold font_size">ID</div>
                                    <div className="mt-3 col-10 col-lg-6">
                                        <TextBox value={this.state.editServiceFeeFormData.id} readOnly={true} />
                                    </div>
                                </div>
                                <section style={{ marginTop: "55px" }}>
                                    {this.state.IsShowSuccess ? (
                                        <span className="text-success">Data Saved Successfully!</span>
                                    ) : null}
                                    {this.state.IsShowError && this.state.errorMessage != null ? (
                                        <span className="unscheduled-shift">
                                            <ul>
                                                {this.state.errorMessage.map((item: any, uniqueKey: number) => {
                                                    return (
                                                        <li key={uniqueKey}>
                                                            {item.columnName}: {item.errorMessage}
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </span>
                                    ) : null}
                                    {/* {this.state.validationMessage != "" ? (
                                                <>
                                                    {" "}
                                                    <br />{" "}
                                                    <span className="text-danger font-weight-bold justify-content-center">
                                                        <li>{this.state.validationMessage}</li>
                                                    </span>{" "}
                                                </>
                                            ) : null} */}
                                </section>
                            </div>
                            <div className="templateImage">
                                <div className="row">
                                    <div className="col-12 col-lg-5">
                                        <div className="artist-profile__primary-image__container">
                                            <div className="artist-profile__primary-image artist-profile__primary-image--edit-mode">
                                                <>
                                                    <img
                                                        src={
                                                            this.state.promotionPhotoHolder
                                                                ? this.state.promotionPhotoHolder
                                                                : "/assets/images/event-UK-image.jpeg"
                                                        }
                                                    />
                                                    <FileUploader
                                                        className="multi-image-banner__image-upload-button"
                                                        selectButtonText="Select Image"
                                                        uploadMode="useForm"
                                                        showFileList={false}
                                                        onValueChanged={this.onValueChangedForPromotionPhoto}
                                                        onInitialized={this.onPrimaryPhotoUploadInitialize}
                                                    ></FileUploader>
                                                </>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-3 col-2 col-lg-2">
                                    <CheckBox
                                        value={this.state.editServiceFeeFormData.active}
                                        onValueChanged={this.handleChangeActive}
                                        width={150}
                                        text="Active?"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="buttons row" style={{ marginLeft: "1rem", marginTop: "2rem" }}>
                            <div className="col-12 col-lg-2 mt-3">
                                <Link
                                    to={{
                                        pathname: "/matrixView",
                                        state: {
                                            isCancel: true,
                                        },
                                    }}
                                    className="btn btn--ghost btn--large"
                                >
                                    <span className="btn__icon">
                                        <FontAwesomeIcon icon={faTimes} />
                                    </span>
                                    {this.props.t("addEditShiftRow.financeSection.cancelButton.text")}
                                </Link>
                            </div>
                            <div className="col-12 col-lg-2 mt-3">
                                <button
                                    className="btn btn--ghost btn--large"
                                    type="button"
                                    onClick={(e: MouseEvent) => {
                                        e.preventDefault();
                                        this.onApplyClick("save");
                                    }}
                                >
                                    <span className="btn__icon"></span>
                                    SAVE
                                </button>
                            </div>
                            <div className="col-12 col-lg-2 mt-3">
                                <button
                                    className="btn btn-primary btn--large"
                                    type="button"
                                    onClick={(e: MouseEvent) => {
                                        e.preventDefault();
                                        this.onApplyClick("apply");
                                    }}
                                >
                                    <span className="btn__icon"></span>
                                    {this.props.t("addEditShiftRow.financeSection.applyButton.text")}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </>
        );
    }
}

export default withTranslation()(PromotionTemplatesForm);
